document.addEventListener('DOMContentLoaded', function () {
  // Respect the visitor's accessibility preference
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  const sections = document.querySelectorAll(
    'main .shopify-section:not(:first-child)'
  );

  if (!sections.length) return;

  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    {
      threshold: 0.12,
      rootMargin: '0px 0px -40px 0px'
    }
  );

  sections.forEach(function (section) {
    section.classList.add('igyb-reveal');
    observer.observe(section);
  });
});